<div fxLayout="row" fxFlex.lt-md="100%" class="templating-config-fields-container">
  <div fxFlex="100">
    <mat-card>
      <div fxLayout="row">
        <h3>{{configMap.prefix ? configMap.prefix : rootPrefix}}</h3>
      </div>

      <div fxLayout="row">
        <mat-selection-list fxFlex [multiple]="false" fxLayout="row wrap">
          <mat-list-option *ngFor="let field of configMap.config.fields" fxFlex="33" (click)="copy((configMap.prefix ? configMap.prefix + '.' : '') + field.name)">
            {{configMap.prefix ? configMap.prefix + '.' : ''}}{{field.name}}
          </mat-list-option>
        </mat-selection-list>
      </div>

    </mat-card>
  </div>
</div>
